// TODO move this file to trelloFetchBatch.ts in @trello/fetch
import { apiErrorFromResponse } from 'app/scripts/network/apiErrorFromResponse';
import customError from '@atlassian/trello-error-ext';
import { getInvitationTokens } from '@trello/invitation-tokens';
import { sendNetworkErrorEvent } from '@trello/error-reporting';
import { trelloFetch } from '@trello/fetch';

// eslint-disable-next-line @trello/no-module-logic
export const BatchFailure = customError('Batcher::BatchFailure');

const getErrorText = async (response: Response) => {
  try {
    const json = await response.json();
    if (json) {
      return JSON.stringify(json);
    }
  } catch (err) {
    // noop
  }

  try {
    const text = await response.text();
    if (text) {
      return text;
    }
  } catch (err) {
    // noop
  }

  return response.statusText;
};

interface ErrorResponse {
  name: string;
  message: string;
  statusCode: number;
  stack: string;
}
type SuccessResponse = Record<'200', object>;

export const trelloBatchFetch = async <ResponseBody>(
  urls: string[],
  options: {
    operationName: string;
    headers?: Record<string, string | boolean | undefined>;
  },
) => {
  let apiUrl = `/1/batch?urls=${encodeURIComponent(urls.join(','))}`;

  const invitationTokens = getInvitationTokens();
  if (invitationTokens) {
    apiUrl = `${apiUrl}&invitationTokens=${encodeURIComponent(
      invitationTokens || '',
    )}`;
  }

  const response = await trelloFetch(
    // eslint-disable-next-line @trello/no-batch-queries
    apiUrl,
    {
      method: 'GET',
      headers: {
        ...(options.headers || {}),
      },
    },
    {
      networkRequestEventAttributes: {
        source: 'batch',
        operationName: options.operationName,
      },
    },
  );

  const results: [string, Error | null, ResponseBody | null][] = [];

  if (!response.ok) {
    const errorMessage = await getErrorText(response);
    const error = apiErrorFromResponse(response.status, errorMessage);
    sendNetworkErrorEvent({
      status: response.status,
      response: error.toString(),
      url: '/1/batch',
    });
    throw error;
  }

  const data: [SuccessResponse | ErrorResponse] = await response.json();

  for (let i = 0; i < data.length; i++) {
    const result = data[i];
    const url = urls[i];

    if ('200' in result) {
      results.push([url, null, (result['200'] as unknown) as ResponseBody]);
    } else {
      const apiError = apiErrorFromResponse(result.statusCode, result.message);
      sendNetworkErrorEvent({
        status: result.statusCode,
        response: apiError.toString(),
        url: '/1/batch',
      });
      results.push([url, apiError, null]);
    }
  }

  return results;
};
